
<div class="row" >

<div *ngIf="load" align="center" style="width:100%; height:100%; position:absolute; left:0px; top:0px; z-index:2; background-color: #ffffff91">
	<br><br><br>
	<!-- <fa name="spinner" size='4x' animation="spin"> </fa> -->
		<br>
		<br>
		<p class="text-loading" style="font-family:'Poppins', sans-serif;font-weight: 600;"> En el plazo de 48hs recibirá la información sobre la activación de su usuario. </p>
</div>



<form class="col-12 col-md-12" [formGroup]="form" (ngSubmit)="onSubmit();" novalidate *ngIf="!load">
  <div class="modal-body row shadow-sm  p-3 mb-5 bg-white rounded box-form">
    <div class="col-12 pt-3">
      <p style="font-size: 18px; font-weight: 600; text-transform: uppercase; text-align:center;"
          [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">exclusivo para empresas de turismo</p>
    </div>
	    <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nombre de la agencia</label>
				<input
                type="text"
                formControlName="TravelAgencyName"
                [ngClass]="{
                  'is-invalid': form.get('TravelAgencyName')?.touched && form.get('TravelAgencyName')?.invalid,
                  'is-valid': form.get('TravelAgencyName')?.touched && form.get('TravelAgencyName')?.valid
                }"
                class="form-control text-field"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="60"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required

        >
					<span class=" booking  position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.TravelAgencyName.touched && form.controls.TravelAgencyName.invalid && (!form.controls.TravelAgencyName.errors?.minlength || !form.controls.TravelAgencyName.errors?.maxlength)">
						Por favor inserte un nombre
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.TravelAgencyName.errors?.minlength || form.controls.TravelAgencyName.errors?.maxlength">
						El nombre debe tener entre 2-60 carácteres
					</span>
			</div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Razón social</label>
				<input
                type="text"
                formControlName="TravelAgencyNameBusiness"
                [ngClass]="{
                  'is-invalid':form.get('TravelAgencyNameBusiness')?.touched &&  form.get('TravelAgencyNameBusiness')?.invalid,
                  'is-valid':form.get('TravelAgencyNameBusiness')?.touched && form.get('TravelAgencyNameBusiness')?.valid
                }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="60"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                class="form-control text-field"
                required

        >
					<span class=" booking  position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.TravelAgencyNameBusiness.touched && form.controls.TravelAgencyNameBusiness.invalid && (!form.controls.TravelAgencyNameBusiness.errors?.minlength || !form.controls.TravelAgencyNameBusiness.errors?.maxlength)">
						Por favor inserte una razón social
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.TravelAgencyNameBusiness.errors?.minlength || form.controls.TravelAgencyNameBusiness.errors?.maxlength">
					 La razón social debe tener entre 2-60 carácteres
					</span>
			</div>
	    </div>
	    <div class="col-12 col-md-6 form-item pt-2">
			<div>
				<label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nombre del propietario</label>
				<input class="form-control text-field"
                formControlName="Contact"
                type="text"
                [ngClass]="{
                  'is-invalid':  form.get('Contact')?.touched && form.get('Contact')?.invalid,
                  'is-valid': form.get('Contact')?.touched && form.get('Contact')?.valid
                }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="60"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
                >

					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.Contact.touched && form.controls.Contact.invalid && (!form.controls.Contact.errors?.minlength || !form.controls.Contact.errors?.maxlength)">
						Por favor inserte un nombre
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.Contact.errors?.minlength || form.controls.Contact.errors?.maxlength">
						El nombre debe tener entre 2-60 carácteres
					</span>

			</div>
	    </div>
      	    <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Ubicación</label>
          <select
                  class="form-control text-field"
                  [ngClass]="{
                    'is-invalid':form.get('LocationAgencyId')?.touched &&  form.get('LocationAgencyId')?.invalid,
                    'is-valid':form.get('LocationAgencyId')?.touched && form.get('LocationAgencyId')?.valid
                  }"
                  formControlName="LocationAgencyId"

                  required>
            <option disabled> Selecciona una ubicación</option>
            <ng-container *ngFor="let co of locationAgency">
              <option value="{{co.id}}" style="text-transform: capitalize;" > {{co.location_name}}</option>
            </ng-container>
          </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf="form.controls.LocationAgencyId.touched && form.controls.LocationAgencyId.invalid ">
              Por favor seleccione una ubicación
            </span>
          </div>
        </div>
      	    <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Sitio web</label>
				<input class="form-control text-field"
                [ngClass]="{
                  'is-invalid':form.get('Website').touched && (form.get('Website').errors && form.get('Website').errors.errorWebsiteFormat || form.get('Website').value === null || form.get('Website').value === ''),
                  'is-valid':form.get('Website').touched &&( form.get('Website').value !== null || form.get('Website').value !== '')
                }"
                type="text"
                (input)="webDetectError($event)"
                name="Website"
                formControlName="Website"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="80"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
                >
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px;color: #dc3545 !important" *ngIf="form.controls.Website.touched && form.controls.Website.invalid && !form.controls.Website.errors?.pattern">
						Por favor inserte un sitio web
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px;color: #dc3545 !important" *ngIf="form.controls.Website.errors?.pattern">
						Inserte una dirección valida
					</span>
			</div>
	    </div>


      <div class="col-12 col-md-6 form-item pt-2">
			<div>
				<label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Email
        </label>
				<input class="form-control text-field"
                type="email"
                formControlName="EmailContactAgency"
                [ngClass]="{
                  'is-invalid': form.get('EmailContactAgency').touched &&  form.get('EmailContactAgency').invalid,
                  'is-valid': form.get('EmailContactAgency').touched && form.get('EmailContactAgency').valid
                }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
                >
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.EmailContactAgency.touched && form.controls.EmailContactAgency.invalid && !form.controls.EmailContactAgency.errors?.pattern">
						Por favor inserte un email
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.EmailContactAgency.errors?.pattern">
						Inserte un email valido
					</span>
			</div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Legajo / Licencia / Lata</label>
          <input class="form-control text-field"
                  formControlName="Legajo"
                  type="text"
                  [ngClass]="{
                    'is-invalid':form.get('Legajo').touched &&  form.get('Legajo').invalid,
                    'is-valid':form.get('Legajo').touched && form.get('Legajo').valid
                  }"
                  (paste)="$event.preventDefault()"
                  (drop)="$event.preventDefault()"
                  (contextmenu)="$event.preventDefault()"
                  [maxLength]="100"
                  minLength="1"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  required
                  >

            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.Legajo.touched && form.controls.Legajo.invalid && (!form.controls.legajo?.errors?.minlength || !form.controls.legajo?.errors?.maxlength)">
              Por favor inserte un legajo
            </span>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.Legajo?.errors?.minlength || form.controls.Legajo?.errors?.maxlength">
              El legajo debe tener entre 2-60 carácteres
            </span>
        </div>

			</div>
	    <div class="col-12 col-md-6 form-item pt-2">
			<div>
				<label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Identificación de impuesto</label>
				<input class="form-control text-field"
                formControlName="TaxId"
                type="text"
                [ngClass]="{
                  'is-invalid': form.get('TaxId').touched && form.get('TaxId').invalid,
                  'is-valid':form.get('TaxId').touched && form.get('TaxId').valid
                }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="60"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
                >

					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.TaxId.touched && form.controls.TaxId.invalid && (!form.controls.TaxId.errors?.minlength || !form.controls.TaxId.errors?.maxlength)">
						Por favor inserte un n° de impuesto
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.TaxId.errors?.minlength || form.controls.TaxId.errors?.maxlength">
						El n° de impuesto debe tener entre 2-60 carácteres
					</span>

			</div>
	    </div>


            <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">% de viajes en LATAM</label>
          <select class="form-control text-field"
                  formControlName="PercentageTravels"
                  [ngClass]="{
                    'is-invalid': form.get('PercentageTravels').touched && form.get('PercentageTravels').invalid,
                    'is-valid':form.get('PercentageTravels').touched && form.get('PercentageTravels').valid
                  }"
                  required

                  >
            <option value="10-20" > 10% - 20% </option>
            <option value="20-30"> 20% - 30% </option>
            <option value="40-50"> 40% - 50% </option>
            <option value="+50"> + 50% </option>
          </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PercentageTravels.touched && form.controls.PercentageTravels.invalid">
              Debe seleccionar un rango
            </span>
          </div>
	    </div>

	    <div  class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Número de empleados</label>
          <input
                  type="number"
                  class="form-control text-field"
                  formControlName="NumberEmployee"
                  [ngClass]="{
                    'is-invalid': form.get('NumberEmployee').touched && form.get('NumberEmployee').invalid,
                    'is-valid':form.get('NumberEmployee').touched && form.get('NumberEmployee').valid
                  }"
                  (paste)="$event.preventDefault()"
                  (drop)="$event.preventDefault()"
                  (contextmenu)="$event.preventDefault()"
                  [min]=0
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  required>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.NumberEmployee.touched && form.controls.NumberEmployee.invalid">
              Debe seleccionar un número
            </span>
        </div>
	    </div>

            <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nro. telefónico</label>
          <div class="d-flex">
            <div style="width: 100%">
              <select class="form-control text-field"
                      id="PhoneCode"
                      [ngClass]="{
                        'is-invalid':form.get('PhoneCode').touched &&  form.get('PhoneCode').invalid,
                        'is-valid':form.get('PhoneCode').touched && form.get('PhoneCode').valid
                      }"
                      formControlName="PhoneCode"
              >
                <option value="null" disabled></option>
                <option *ngFor="let country of countries"
                        [value]="country.phone_code">
                          {{country.country_name}} (+{{country.phone_code}})
                </option>
              </select>
            </div>
            <div style="margin-left: 6px;">
              <input class=" form-control text-field"
                     type="number"
                     [ngClass]="{
                      'is-invalid':form.get('PhoneNumber').touched && form.get('PhoneNumber').invalid,
                      'is-valid':form.get('PhoneNumber').touched && form.get('PhoneNumber').valid
                    }"
                     formControlName="PhoneNumber"
                     (paste)="$event.preventDefault()"
                      (drop)="$event.preventDefault()"
                      (contextmenu)="$event.preventDefault()"
                      minLength="2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      (keydown)="blockInvalidKeys($event, 'number')"
                     required>
            </div>
          </div>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PhoneNumber.touched && form.controls.PhoneNumber.invalid && !form.controls.PhoneNumber.errors?.pattern">
              Debe insertar un número telefónico
            </span>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PhoneNumber.errors?.pattern">
              Inserte un número de telefóno valido
            </span>
        </div>
	    </div>



      <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nro. telefónico whatsapp</label>
          <div class="d-flex">
            <div style="width: 100%">
              <select class="form-control text-field"
                      id="PhoneCodeWsp"
                      [ngClass]="{
                        'is-invalid': form.get('PhoneCodeWsp').touched && form.get('PhoneCodeWsp').invalid,
                        'is-valid':form.get('PhoneCodeWsp').touched && form.get('PhoneCodeWsp').valid
                      }"
                      formControlName="PhoneCodeWsp"
              >
                <option value="null" disabled></option>
                <option *ngFor="let country of countries"
                        [value]="country.phone_code">
                          {{country.country_name}} (+{{country.phone_code}})
                </option>
              </select>
            </div>
            <div style="margin-left: 6px;">
              <input class=" form-control text-field"
                     type="number"
                     [ngClass]="{
                      'is-invalid': form.get('PhoneWsp').touched && form.get('PhoneWsp').invalid,
                      'is-valid':form.get('PhoneWsp').touched && form.get('PhoneWsp').valid
                    }"
                     formControlName="PhoneWsp"
                     (paste)="$event.preventDefault()"
                      (drop)="$event.preventDefault()"
                      (contextmenu)="$event.preventDefault()"
                      minLength="2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      (keydown)="blockInvalidKeys($event, 'number')"
                     required>
            </div>
          </div>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PhoneWsp.touched && form.controls.PhoneWsp.invalid && !form.controls.PhoneWsp.errors?.pattern">
              Debe insertar un número telefónico
            </span>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PhoneWsp.errors?.pattern">
              Inserte un número de telefóno valido
            </span>
        </div>
	    </div>

      <div class="col-12 form-item pt-2 pb-5 mt-4">
          <div>
            <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Descripción agencia</label>
            <textarea class="form-control text-field"
                      style="height:150px;"
                      formControlName="DescriptionAgency"
                      [value]="form.value.DescriptionAgency"
                      (paste)="$event.preventDefault()"
                      (drop)="$event.preventDefault()"
                      (contextmenu)="$event.preventDefault()"
                      [maxLength]="200"
                      minLength="2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      ></textarea>
              <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf=" form.controls.DescriptionAgency.touched && form.controls.DescriptionAgency.invalid">
                La descripción debe contener como máximo 200 carácteres
              </span>
          </div>
      </div>

      <!-- Nuevo -->

      <div class="col-12 pt-3">
             <p style="font-size: 18px; font-weight: 600; text-transform: uppercase; text-align:center;"
          [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Información ubicación</p>
      </div>

      <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">País</label>
          <select
                  class="form-control text-field"
                  [ngClass]="{
                    'is-invalid': form.get('Country').touched && form.get('Country').invalid,
                    'is-valid':form.get('Country').touched && form.get('Country').valid
                  }"
                  formControlName="Country"
                  (change)="getDestinations($event.target.value)"
                  required>
            <option disabled> Selecciona un país</option>
            <option *ngFor="let co of countries" value="{{co.country_code}}" style="text-transform: capitalize;" > {{co.country_name}}</option>
          </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf="form.controls.Country.touched && form.controls.Country.invalid ">
              Por favor seleccione un país
            </span>
          </div>
        </div>
        <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Región</label>
          <select
                  class="form-control text-field"
                  [ngClass]="{
                    'is-invalid': form.get('Destination').touched && form.get('Destination').invalid,
                    'is-valid':form.get('Destination').touched && form.get('Destination').valid
                  }"
                  formControlName="Destination"
                  (change)="getCities($event.target.value)"
                  required>
            <option disabled> Selecciona una región</option>
            <option *ngFor="let de of destinations" value="{{de.destination_id}}" style="text-transform: capitalize;" > {{de.destination_name}}</option>
          </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf="form.controls.Destination.touched && form.controls.Destination.invalid ">
              Por favor seleccione una región
            </span>
        </div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Ciudad</label>
          <select
                  class="form-control text-field"
                  [ngClass]="{
                    'is-invalid': form.get('City').touched && form.get('City').invalid,
                    'is-valid':form.get('City').touched && form.get('City').valid
                  }"
                  formControlName="City"
                  required>
            <option disabled> Selecciona una ciudad</option>
            <option *ngFor="let ci of cities" value="{{ci.city_id}}" style="text-transform: capitalize;" > {{ci.city_name}}</option>
          </select>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf="form.controls.Country.touched && form.controls.Country.invalid ">
              Por favor seleccione un ciudad
            </span>
        </div>
      </div>

      	    <div  class="col-12 col-md-6 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Código postal</label>
          <input
                  type="text"
                  class="form-control text-field"
                  formControlName="ZipCode"
                  [ngClass]="{
                    'is-invalid': form.get('ZipCode').touched && form.get('ZipCode').invalid,
                    'is-valid':form.get('ZipCode').touched && form.get('ZipCode').valid
                  }"
                  (paste)="$event.preventDefault()"
                  (drop)="$event.preventDefault()"
                  (contextmenu)="$event.preventDefault()"
                  [maxLength]="50"
                  minLength="1"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  required>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.ZipCode.touched && form.controls.ZipCode.invalid">
              Debe ingresar un número de código postal
            </span>
        </div>
	    </div>

      <div class="col-12 col-md-12 form-item pt-2">
        <div>
          <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Dirección</label>
          <input
                  type="text"
                  class="form-control text-field"
                  formControlName="Adress"
                  [ngClass]="{
                    'is-invalid': form.get('Adress').touched && form.get('Adress').invalid,
                    'is-valid':form.get('Adress').touched && form.get('Adress').valid
                  }"
                  (paste)="$event.preventDefault()"
                  (drop)="$event.preventDefault()"
                  (contextmenu)="$event.preventDefault()"
                  [maxLength]="100"
                  minLength="1"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  required>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.Adress.touched && form.controls.Adress.invalid">
              Debe ingresar una dirección
            </span>
        </div>
	    </div>


      <div class="col-12 pt-3">
             <p style="font-size: 18px; font-weight: 600; text-transform: uppercase; text-align:center;"
          [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Contacto comercial</p>
      </div>

      <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nombre</label>
				<input
                type="text"
                formControlName="ContactCommercial"
                [ngClass]="{
                  'is-invalid': form.get('ContactCommercial').touched && form.get('ContactCommercial').invalid,
                  'is-valid':form.get('ContactCommercial').touched && form.get('ContactCommercial').valid
                }"
                class="form-control text-field"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="60"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                (keydown)="blockInvalidKeys($event, 'name')"
                required

        >
					<span class=" booking  position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.ContactCommercial.touched && form.controls.ContactCommercial.invalid && (!form.controls.ContactCommercial.errors?.minlength || !form.controls.ContactCommercial.errors?.maxlength)">
						Por favor inserte un nombre
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.ContactCommercial.errors?.minlength || form.controls.ContactCommercial.errors?.maxlength">
						El nombre debe tener entre 2-60 carácteres
					</span>
			</div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-3">
			<div>
				<label class="pl-3" [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Apellido</label>
				<input
                type="text"
                formControlName="ContactCommercialLastName"
                [ngClass]="{
                  'is-invalid': form.get('ContactCommercial').touched && form.get('ContactCommercialLastName').invalid,
                  'is-valid':form.get('ContactCommercial').touched && form.get('ContactCommercialLastName').valid
                }"
                class="form-control text-field"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="60"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                (keydown)="blockInvalidKeys($event, 'name')"
                required

        >
					<span class=" booking  position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.ContactCommercialLastName.touched && form.controls.ContactCommercialLastName.invalid && (!form.controls.ContactCommercialLastName.errors?.minlength || !form.controls.ContactCommercialLastName.errors?.maxlength)">
						Por favor inserte un apellido
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.ContactCommercialLastName.errors?.minlength || form.controls.ContactCommercialLastName.errors?.maxlength">
						El apellido debe tener entre 2-60 carácteres
					</span>
			</div>
	    </div>


	    <div class="col-12 col-md-6 form-item pt-2">
			<div>
				<label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Email</label>
				<input class="form-control text-field"
                type="email"
                formControlName="EmailContactCommercial"
                [ngClass]="{
                  'is-invalid': form.get('EmailContactCommercial').touched && form.get('EmailContactCommercial').invalid,
                  'is-valid':form.get('EmailContactCommercial').touched && form.get('EmailContactCommercial').valid
                }"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                [maxLength]="80"
                minLength="2"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                required
                >
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.EmailContactCommercial.touched && form.controls.EmailContactCommercial.invalid && !form.controls.EmailContactCommercial.errors?.pattern">
						Por favor inserte un email
					</span>
					<span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.EmailContactCommercial.errors?.pattern">
						Inserte un email valido
					</span>
			</div>
	    </div>
      <div class="col-12 col-md-6 form-item pt-2">
        <div>
          <label class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">Nro. telefónico</label>
          <div class="d-flex">
            <div style="width: 100%">
              <select class="form-control text-field"
                      id="PhoneCodeContactCommercial"
                      [ngClass]="{
                        'is-invalid': form.get('PhoneCodeContactCommercial').touched && form.get('PhoneCodeContactCommercial').invalid,
                        'is-valid': form.get('PhoneCodeContactCommercial').touched && form.get('PhoneCodeContactCommercial').valid
                      }"
                      formControlName="PhoneCodeContactCommercial"
                      
              >
                <option value="null" disabled></option>
                <option *ngFor="let country of countries"
                        [value]="country.phone_code">
                          {{country.country_name}} (+{{country.phone_code}})
                </option>
              </select>
            </div>
            <div style="margin-left: 6px;">
              <input class=" form-control text-field"
                     type="number"
                     [ngClass]="{
                      'is-invalid': form.get('PhoneNumberContactCommercial').touched && form.get('PhoneNumberContactCommercial').invalid,
                      'is-valid':form.get('PhoneNumberContactCommercial').touched && form.get('PhoneNumberContactCommercial').valid
                    }"
                     formControlName="PhoneNumberContactCommercial"
                     (paste)="$event.preventDefault()"
                      (drop)="$event.preventDefault()"
                      (contextmenu)="$event.preventDefault()"
                      minLength="2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      (keydown)="blockInvalidKeys($event, 'number')"
                     required>
            </div>
          </div>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PhoneNumberContactCommercial.touched && form.controls.PhoneNumberContactCommercial.invalid && !form.controls.PhoneNumberContactCommercial.errors?.pattern">
              Debe insertar un número telefónico
            </span>
            <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px; color: #dc3545 !important" *ngIf="form.controls.PhoneNumberContactCommercial.errors?.pattern">
              Inserte un número de telefóno valido
            </span>
        </div>
	    </div>


	    <div class="col-12 form-item pt-2 pb-5 mt-4">
          <div>
            <label  class="pl-3"  [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">¿Algún comentario?</label>
            <textarea class="form-control text-field"
                      style="height:150px;"
                      formControlName="Comments"
                      [value]="form.value.Comments"
                      (paste)="$event.preventDefault()"
                      (drop)="$event.preventDefault()"
                      (contextmenu)="$event.preventDefault()"
                      [maxLength]="200"
                      minLength="2"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      ></textarea>
              <span class="s-sm booking position-absolute mt-0.5 ml-1" style="font-size: 10px" *ngIf=" form.controls.Comments.touched && form.controls.Comments.invalid">
                Su comentario debe contener como máximo 200 carácteres
              </span>
          </div>
      </div>
	  </div>
	  <div class="row p-3 leyend rounded rounded-2">
	  	<div class="col-12 col-md-9 pt-3 pl-3">
			<p class="f-justify" class="font-parrafo-white pr-3">
				Completar todos los campos, nos permitirá gestionar mas rápido la configuración del usuario para acceder al sistema. Para ser parte de la suite tecnológica, debes ser un Operador Mayorista constituido legalmente en tu país con las habilitaciones correspondiente. Una vez aceptada la solicitud recibirás un mail con las indicaciones para acceder.
			</p>
		</div>
		<div class="col-12 col-md-12 form-item pt-3 d-flex justify-content-center" *ngIf="turnstileEnabled">
			<app-turnstile
				[siteKey]="turnstileSiteKey"
				action="joinus"
				[invisibleUntilSubmit]="true"
				(verified)="onTurnstileVerified($event)"
				(expired)="onTurnstileExpired()"
				(errored)="onTurnstileError()">
			</app-turnstile>
		</div>
		<div class="col-12 col-md-3 form-item pt-3 text-center">
			<input type="submit" class="btn-button s-l btn-leyend rounded-pill" value="ENVIAR" style="width: 90% !important;"/>
		</div>
	  </div>

</form>

<button *ngIf="!buttonError" class="border-0 bg-white" #openModalErrorJoinUs data-toggle="modal" data-target="#modalResError"></button>

<div class="modal fade center" id="modalResError" tabindex="-1" role="dialog" aria-hidden="true" style="top: 50%;">
  <div class="modal-dialog" role="document">
      <div class="d-flex justify-content-center bg-white modalResSignUp shadow" style="border: 1px solid rgb(204, 204, 204);">
        <div class="modal-header">
          <p style="font-family:'Poppins', sans-serif;font-weight: 600;padding: 14px; margin: 2px;">Este email ya fue registrado, por favor ingrese otro...</p>
          <button #closeButtonModalErrorSignup class="closeButtonModalErrorSignup" type="button" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
  </div>
</div>
</div>






